import { Dot } from 'lucide-react';
import * as React from 'react';
import clsx from 'clsx';
import { OTPInput, OTPInputContext } from 'input-otp';
import styles from './input-otp.module.scss';

const InputOTP = React.forwardRef<React.ElementRef<typeof OTPInput>, React.ComponentPropsWithoutRef<typeof OTPInput> & { hasError?: boolean }>(
  ({ className, containerClassName, hasError = false, ...props }, ref) => (
    <OTPInput
      ref={ref}
      containerClassName={clsx(styles.inputOtpContainer, hasError ? styles.inputOtpHasError : '', containerClassName)}
      className={clsx(styles.otpInput, className)}
      {...props}
    />
  ),
);
InputOTP.displayName = 'InputOTP';

const InputOTPGroup = React.forwardRef<React.ElementRef<'div'>, React.ComponentPropsWithoutRef<'div'>>(({ className, ...props }, ref) => (
  <div ref={ref} className={clsx(styles.inputOtpGroup, className)} {...props} />
));
InputOTPGroup.displayName = 'InputOTPGroup';

const InputOTPSlot = React.forwardRef<React.ElementRef<'div'>, React.ComponentPropsWithoutRef<'div'> & { index: number }>(({ index, className, ...props }, ref) => {
  const inputOTPContext = React.useContext(OTPInputContext);
  const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index];

  return (
    <div ref={ref} className={clsx(styles.inputOtpSlot, className)} {...props}>
      {char}
      {hasFakeCaret && (
        <div className={styles.fakeCaretContainer}>
          <div className={styles.fakeCaret} />
        </div>
      )}
    </div>
  );
});
InputOTPSlot.displayName = 'InputOTPSlot';

const InputOTPSeparator = React.forwardRef<React.ElementRef<'div'>, React.ComponentPropsWithoutRef<'div'>>(({ ...props }, ref) => (
  <div ref={ref} role="separator" {...props} className={styles.otpSeperator}>
    <Dot color="#eff2f5" />
  </div>
));
InputOTPSeparator.displayName = 'InputOTPSeparator';

export { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator };
